<template>
    <div class="compare-card">
        <div class="compare-card__title">Порівняння</div>
        <div class="compare-card__subtitle">останній матч vs сезон</div>
        <div class="compare-card__body">
            <div
                v-for="(item, idx) in items"
                :key="item.key"
                class="compare-card__row"
                :class="{ 'compare-card__row--alt': idx % 2 === 0 }"
            >
                <span class="compare-card__label">{{ item.label }}</span>
                <span
                    class="compare-card__badge"
                    :class="badgeClass(item.value)"
                >
                    {{ formatValue(item.value) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
const METRIC_ROWS = [
    { key: 'total_distance', label: 'Дистанція' },
    { key: 'zone_4', label: 'Зона 4' },
    { key: 'zone_5', label: 'Зона 5' },
    { key: 'zone_6', label: 'Зона 6' },
    { key: 'speed_distance', label: 'Швидк. дист.' },
    { key: 'average_speed', label: 'Сер. швидк.' },
    { key: 'max_speed', label: 'Макс. швидк.' },
    { key: 'sprints', label: 'Спринти' },
    { key: 'starts', label: 'Старт' },
    { key: 'stops', label: 'Стоп' }
]

export default {
    name: 'GpsComparison',

    props: {
        data: {
            type: [Object, Array],
            required: true
        }
    },

    computed: {
        items() {
            if (!this.data) return []

            if (Array.isArray(this.data)) {
                return this.data.map(item => ({
                    key: item.key,
                    label: METRIC_ROWS.find(row => row.key === item.key)?.label || item.key,
                    value: item.value
                }))
            }

            return METRIC_ROWS.map(row => ({
                key: row.key,
                label: row.label,
                value: this.data[row.key] ?? null
            }))
        }
    },

    methods: {
        badgeClass(value) {
            if (value > 0) return 'compare-card__badge--up'
            if (value < 0) return 'compare-card__badge--down'
            return 'compare-card__badge--neutral'
        },

        formatValue(value) {
            if (value == null) return '—'
            const sign = value > 0 ? '+' : ''
            return sign + value + '%'
        }
    }
}
</script>

<style scoped>
.compare-card {
    background: linear-gradient(145deg, #2a2b2b 0%, #252626 100%);
    border: 1px solid #3a3b3b;
    border-radius: 14px;
    padding: 14px 16px 10px;
    height: 100%;
}
.compare-card__title {
    color: #C59014;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.3px;
}
.compare-card__subtitle {
    color: #6b6b6b;
    font-size: 11px;
    margin-bottom: 8px;
}
.compare-card__body {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.compare-card__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px;
    border-radius: 6px;
    transition: background 0.15s;
}
.compare-card__row--alt {
    background: rgba(58, 59, 59, 0.5);
}
.compare-card__row:hover {
    background: rgba(197, 144, 20, 0.08);
}
.compare-card__label {
    color: #7a7a7a;
    font-size: 12px;
}
.compare-card__badge {
    padding: 2px 10px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 11px;
    color: #fff;
    min-width: 52px;
    text-align: center;
    font-variant-numeric: tabular-nums;
}
.compare-card__badge--up {
    background: linear-gradient(135deg, #2e7d32, #43a047);
}
.compare-card__badge--down {
    background: linear-gradient(135deg, #c62828, #e53935);
}
.compare-card__badge--neutral {
    background: #555;
}
</style>
